import { useTranslate } from '@awardit/react-use-translate';

// Finds groups of three digits in a number.
var MATCH_NUMBER_SET = /\B(?=(\d{3})+(?!\d))/g;

// Formats a number-as-string into 12 345.67 format.
var formatNumber = function formatNumber(n) {
  return n.replace(".", ",").replace(MATCH_NUMBER_SET, " ");
};
var formatDate = function formatDate(date) {
  var dt = new Date(date);
  return dt.getFullYear() + "-" + ("00" + (dt.getMonth() + 1)).slice(-2) + "-" + ("00" + dt.getDate()).slice(-2);
};
var useFormat = function useFormat() {
  var t = useTranslate();
  return {
    formatPrice: function formatPrice(price) {
      return (
        // Max 2 decimals, and skip any trailing zeroes
        formatNumber(Number(Number.parseFloat(String(price)).toFixed(2)).toString()) + " " + t("LOCALE.CURRENCY_SHORT")
      );
    },
    formatPoints: function formatPoints(points, label) {
      return formatNumber(points.toFixed(0)) + " " + (label && label !== null ? label : t("LOCALE.POINTS"));
    },
    formatDate: formatDate
  };
};

export default useFormat;
export { MATCH_NUMBER_SET, formatNumber };
//# sourceMappingURL=use-format.js.map
